import axios from "axios";
import _ from "lodash";
import {axiosCatchHandler} from "../sharedGlobal";

const SET_CHOSEN_KEYWORDS = 'SET_CHOSEN_KEYWORDS';
const SET_PREVIOUS_TOPICS = 'SET_PREVIOUS_TOPICS';
const SET_SUGGESTED_TOPICS = 'SET_SUGGESTED_TOPICS';
const SET_GENERATING_SUGGESTED_TOPICS = 'SET_GENERATING_SUGGESTED_TOPICS';
const SET_SUGGESTIONS = 'SET_SUGGESTIONS';
const SET_ADDING_SUGGESTION = 'SET_ADDING_SUGGESTION';
const SET_LOADING_SUGGESTIONS = 'SET_LOADING_SUGGESTIONS';
const SET_REMOVING_KEYWORD = 'SET_REMOVING_KEYWORD';
const ADD_NEW_CHOSEN_KEYWORD = 'ADD_NEW_CHOSEN_KEYWORD';
const ADD_NEW_CHOSEN_KEYWORDS = 'ADD_NEW_CHOSEN_KEYWORDS';
const CLEAR_NEW_CHOSEN_KEYWORD = 'CLEAR_NEW_CHOSEN_KEYWORD';
const REMOVE_NEW_CHOSEN_KEYWORD = 'REMOVE_NEW_CHOSEN_KEYWORD';
const REMOVE_CHOSEN_KEYWORD = 'REMOVE_CHOSEN_KEYWORD';
const CLEAR_REMOVE_CHOSEN_KEYWORDS = 'CLEAR_REMOVE_CHOSEN_KEYWORDS';
const IGNORE_REMOVE_CHOSEN_KEYWORD = 'IGNORE_REMOVE_CHOSEN_KEYWORD';

const SET_TYPE_FILTER = 'SET_TYPE_FILTER';
const SET_KEYWORD_FILTER = 'SET_KEYWORD_FILTER';
const SET_COMPETITOR_FILTER = 'SET_COMPETITOR_FILTER';
const SET_SEARCH_FILTER = 'SET_SEARCH_FILTER';
const CLEAR_FILTER= 'CLEAR_FILTER';
const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS';

const SET_IGNORE_FILTERS = 'SET_IGNORE_FILTERS';
const UPDATE_FILTER_COUNT = 'UPDATE_FILTER_COUNT';
const SET_ONBOARDING_STATE = 'SET_ONBOARDING_STATE';
const ADD_KEYWORD_RANKING_REQUEST = 'ADD_KEYWORD_RANKING_REQUEST';
const SET_SHOW_CHOSEN_KEYWORDS_MODAL_STATE = 'SET_SHOW_CHOSEN_KEYWORDS_MODAL_STATE';
const SET_SHOW_BLUK_ADD_MODAL_STATE = 'SET_SHOW_BLUK_ADD_MODAL_STATE';
const SET_BULK_ADD_PREFILL = 'SET_BULK_ADD_PREFILL';
const SET_SORT = 'SET_SORT';

const SET_LOADING_EXISTING_KEYWORD_REVIEWS = 'SET_LOADING_EXISTING_KEYWORD_REVIEWS';
const SET_EXISTING_KEYWORD_REVIEWS = 'SET_EXISTING_KEYWORD_REVIEWS';
const SET_KEYWORD_REVIEWS = 'SET_KEYWORD_REVIEWS';
export const SET_REVIEW_ENABLED = 'SET_REVIEW_ENABLED';
const SET_REVIEW_POLL_COUNT = 'SET_REVIEW_POLL_COUNT';
const SET_SAVING_KEYWORDS = 'SET_SAVING_KEYWORDS';


const filterMutations = {
  'typeFilter': SET_TYPE_FILTER,
  'keywordFilter': SET_KEYWORD_FILTER,
  'searchFilter': SET_SEARCH_FILTER,
  'competitorFilter': SET_COMPETITOR_FILTER,
};

const state = {
  keywordLimit: 0,
  chosenKeywords: [],
  savedChosenKeywords: [],
  previousTopics: null,
  suggestedTopics: null,
  generatingSuggestedTopics: false,

  suggestions: [],
  nextPageUrl: null,

  newChosenKeywords: [],
  removeChosenKeywords: [],

  sortBy: 'search_volume',
  sortDirection: 'desc',
  typeFilter: null,
  keywordFilter: null,
  competitorFilter: null,
  searchFilter: null,
  ignoreFilters: [],

  loadingSuggestions: true,
  addingSuggestion: null,
  removingKeyword: null,

  onboarding: false,

  rankingKeywordRequests: [],

  showChosenKeywordsModal: false,
  showBulkAddModal: false,
  bulkAddPrefill: '',

  reviewEnabled: false,
  keywordReviews: [],
  keywordReviewPollingCount: 0,
  loadingExistingReviews: false,
  existingReviews: null,

  savingKeywords: false,
};

const getters = {
  keywordLimit: ({ keywordLimit }) => keywordLimit,
  chosenKeywords: ({ chosenKeywords }) => chosenKeywords,
  savedChosenKeywords: ({ savedChosenKeywords }) => savedChosenKeywords,
  previousTopics: ({ previousTopics }) => previousTopics,
  suggestedTopics: ({ suggestedTopics }) => suggestedTopics,
  generatingSuggestedTopics: ({ generatingSuggestedTopics }) => generatingSuggestedTopics,
  suggestions: ({ suggestions }) => suggestions,
  newChosenKeywords: ({ newChosenKeywords }) => newChosenKeywords,
  removeChosenKeywords: ({ removeChosenKeywords }) => removeChosenKeywords,
  typeFilter: ({ typeFilter }) => typeFilter,
  keywordFilter: ({ keywordFilter }) => keywordFilter,
  competitorFilter: ({ competitorFilter }) => competitorFilter,
  searchFilter: ({ searchFilter }) => searchFilter,
  ignoreFilters: ({ ignoreFilters }) => ignoreFilters,
  removingKeyword: ({ removingKeyword }) => removingKeyword,
  addingSuggestion: ({ addingSuggestion }) => addingSuggestion,
  loadingSuggestions: ({ loadingSuggestions }) => loadingSuggestions,
  onboarding: ({ onboarding }) => onboarding,
  showChosenKeywordsModal: ({ showChosenKeywordsModal }) => showChosenKeywordsModal,
  showBulkAddModal: ({ showBulkAddModal }) => showBulkAddModal,
  bulkAddPrefill: ({ bulkAddPrefill }) => bulkAddPrefill,
  canLoadMoreSuggestions: ({ nextPageUrl }) => nextPageUrl != null,
  sortBy: ({ sortBy }) => sortBy,
  sortDirection: ({ sortDirection }) => sortDirection,
  loadingExistingReviews: ({ loadingExistingReviews }) => loadingExistingReviews,
  existingReviews: ({ existingReviews }) => existingReviews,
  reviewEnabled: ({ reviewEnabled }) => reviewEnabled,
  keywordReviews: ({ keywordReviews }) => keywordReviews,
  pendingKeywordReviews: ({ keywordReviews }) => keywordReviews.filter(({reviewed_at}) => reviewed_at === null),
  keywordIdsForReview: ({ chosenKeywords, existingReviews, newChosenKeywords, removeChosenKeywords }) => {
    if (!existingReviews) {
      return [];
    }

    // @TODO: revisit this logic and chosen keywords arrays overall
    const notRemovedExistingReviews = existingReviews
        .filter(existing =>
            !removeChosenKeywords
              .find(removed => removed.keyword_index_id === existing.keyword_index_id)
        );

    return [
      ...newChosenKeywords.map(keyword => keyword.id),
      ...chosenKeywords
        .filter(chosen =>
          !notRemovedExistingReviews
            .find(existing => existing.keyword_index_id === chosen.keyword_index_id)?.decision
        )
        .map(keyword => keyword.keyword_index_id),
    ]
  },
  savingKeywords: ({ savingKeywords }) => savingKeywords,
};

const actions = {
  async fetchData({dispatch}) {
    return new Promise((resolve, reject) => {
      Promise.all([
          dispatch('fetchChosenKeywords'),
          dispatch('fetchPreviousTopics'),
          dispatch('fetchSuggestedTopics'),
          dispatch('fetchSuggestions', true),
          dispatch('fetchIgnoreFilters'),
        ])
        .then(() => {
          resolve();
        })
        .catch(
          (e) => axiosCatchHandler(e, () => reject())
        );
    });
  },
  fetchChosenKeywords: ({commit}) =>
    axios.get('/ajax/keywords/get-chosen-keywords')
      .then(({ data } ) => commit(SET_CHOSEN_KEYWORDS, data)),
  fetchChosenKeywordsCount: () =>
    axios.get('/ajax/keywords/get-chosen-keywords?count_only=true')
      .then(({ data }) => data),
  fetchPreviousTopics: ({commit}) =>
    axios.get('/ajax/keywords/get-previous-topics')
      .then(({ data }) => commit(SET_PREVIOUS_TOPICS, data)),
  fetchSuggestedTopics: ({commit}) =>
      axios.get('/ajax/keywords/get-suggested-topics')
          .then(({ data }) => commit(SET_SUGGESTED_TOPICS, data)),
  fetchSuggestions({state, commit}, fresh = false) {
    commit(SET_LOADING_SUGGESTIONS, true);
    const {
      nextPageUrl,
      typeFilter,
      keywordFilter,
      competitorFilter,
      searchFilter,
      sortBy,
      sortDirection,
    } = state;

    let params = {};

    const url = nextPageUrl && !fresh
      ? nextPageUrl
      : '/ajax/keywords/get-keyword-suggestions';

    if (!nextPageUrl || fresh) {
      params = {
        sortBy,
        sortDirection,
        typeFilter,
        keywordFilter,
        competitorFilter,
        searchFilter
      };
    }

    return axios.get(url, {
        params,
      })
      .then(({ data }) => {
        commit(SET_SUGGESTIONS, {data, fresh});
        commit(SET_LOADING_SUGGESTIONS, false);
      })
      .catch(axiosCatchHandler);
  },
  fetchIgnoreFilters: ({commit}) =>
    axios.get('/ajax/keywords/get-ignore-filters')
      .then(({ data }) => commit(SET_IGNORE_FILTERS, data)),
  addSuggestedKeyword: ({commit}, keyword) => commit(ADD_NEW_CHOSEN_KEYWORD, keyword),
  addKeywordSuggestion: ({state, commit, dispatch}, keyword) => {
    commit(SET_ADDING_SUGGESTION, keyword)
    return new Promise((resolve, reject) => {
      axios.post('/ajax/keywords/add-keyword-suggestion', {
        keyword: keyword.trim().toLowerCase()
      })
      .then(async ({data}) => {
        const {count} = data;
        dispatch('fetchPreviousTopics');
        resolve(count);
      })
      .catch((e) => axiosCatchHandler(e, ({response}) => reject(response)))
      .finally(() => commit(SET_ADDING_SUGGESTION, null));
    });
  },
  bulkAddKeywordSuggestions: ({commit}, {keywords, chosenKeywords, newChosenKeywords}) =>
    new Promise((resolve, reject) => {
      axios.post('/ajax/keywords/bulk-add-keyword-suggestions', {
          keywords: keywords,
          chosen_keywords: chosenKeywords,
          new_chosen_keywords: newChosenKeywords,
        })
        .then(async (response) => {
          if (response.data.error){
            return reject(response.data.error);
          }
          let data = response.data;
          await commit(ADD_NEW_CHOSEN_KEYWORDS, data);
          resolve(data);
        }).catch(
          (e) => axiosCatchHandler(e, ({response}) => reject(response))
        );
    }),
  removePreviousKeyword: ({state, commit, dispatch}, data) => {
    commit(SET_REMOVING_KEYWORD, data);

    axios.post('/ajax/keywords/delete-keyword-suggestion', {
      keyword: data
    })
    .then(async () => {
      await dispatch('fetchData');
      if (data === state.keywordFilter) {
        await dispatch('clearFilter', 'keywordFilter');
      }
    })
    .finally(() => commit(SET_REMOVING_KEYWORD, null));
  },
  updateKeywords: ({state, commit, dispatch}, data) => {
    commit(SET_SAVING_KEYWORDS, true);
    return axios.post('/ajax/keywords/update-keywords', data)
        .then(async () => {
          await commit(CLEAR_NEW_CHOSEN_KEYWORD);
          await commit(CLEAR_REMOVE_CHOSEN_KEYWORDS);
          await dispatch('fetchData');
          await commit(SET_SAVING_KEYWORDS, false);
        })
        .catch(axiosCatchHandler)
        .finally(() => {
          commit(SET_SAVING_KEYWORDS, false);
        })
  },
  addIgnoreFilter: ({state, dispatch}, filter) => {
    let filters = [...state.ignoreFilters];
    filters.push(filter);

    return axios.post('/ajax/keywords/update-ignore-filters', {
        filters: filters
      })
      .then(() => dispatch('fetchData'));
  },
  removeIgnoreFilter: ({state, dispatch}, index) => {
    let filters = _.cloneDeep(state.ignoreFilters);
    filters.splice(index, 1);

    return axios.post('/ajax/keywords/update-ignore-filters', {
        filters: filters
      })
      .then(() => dispatch('fetchData'));
  },
  setChosenKeywords: ({commit}, payload) => commit(SET_CHOSEN_KEYWORDS, payload),
  setPreviousTopics: ({commit}, payload) => commit(SET_PREVIOUS_TOPICS, payload),
  setSuggestions: ({commit}, payload) => commit(SET_SUGGESTIONS, payload),
  addNewChosenKeyword({commit, getters, dispatch}, keyword) {
    commit(ADD_NEW_CHOSEN_KEYWORD, keyword);
    if (getters.onboarding) {
      dispatch('addKeywordRankingRequest', keyword);
    }
  },
  addNewChosenKeywords: ({commit}, payload) => commit(ADD_NEW_CHOSEN_KEYWORDS, payload),
  clearNewChosenKeyword: ({commit}) => commit(CLEAR_NEW_CHOSEN_KEYWORD),
  removeNewChosenKeyword: ({commit}, payload) => commit(REMOVE_NEW_CHOSEN_KEYWORD, payload),
  removeChosenKeyword: ({commit}, payload) => commit(REMOVE_CHOSEN_KEYWORD, payload),
  ignoreRemoveChosenKeyword: ({commit}, payload) => commit(IGNORE_REMOVE_CHOSEN_KEYWORD, payload),
  clearRemoveChosenKeywords: ({commit}) => commit(CLEAR_REMOVE_CHOSEN_KEYWORDS),

  setFilter({commit, dispatch}, {key, value}) {
    commit(filterMutations[key], value);
    dispatch('fetchSuggestions', true);
  },
  clearFilter({commit, dispatch}, key) {
    commit(CLEAR_FILTER, key);
    dispatch('fetchSuggestions', true);
  },
  clearAllFilters({commit, dispatch}) {
    commit(CLEAR_ALL_FILTERS);
    dispatch('fetchSuggestions', true);
  },

  setIgnoreFilters: ({commit}, payload) => commit(SET_IGNORE_FILTERS, payload),
  setOnboardingState: ({commit}, payload) => commit(SET_ONBOARDING_STATE, payload),
  addKeywordRankingRequest: ({commit}, keyword) => commit(ADD_KEYWORD_RANKING_REQUEST, keyword),
  openChosenKeywordsModal({commit}) {
    commit(SET_SHOW_CHOSEN_KEYWORDS_MODAL_STATE, true);
  },
  async closeChosenKeywordsModal({commit, dispatch, state}) {
    if (state.reviewEnabled) {
      await dispatch('resetKeywordReview');
    }

    commit(SET_SHOW_CHOSEN_KEYWORDS_MODAL_STATE, false);
  },
  openBulkAddModal({commit}) {
    commit(SET_SHOW_BLUK_ADD_MODAL_STATE, true);
  },
  closeBulkAddModal({commit}) {
    commit(SET_SHOW_BLUK_ADD_MODAL_STATE, false);
  },
  updateBulkAddPrefill({commit}, prefill) {
    commit(SET_BULK_ADD_PREFILL, prefill);
  },
  setSort({commit, dispatch}, sortBy) {
    commit(SET_SORT, sortBy);
    dispatch('fetchSuggestions', true);
  },
  fetchExistingReviews: ({ commit, state }) => {
    commit(SET_LOADING_EXISTING_KEYWORD_REVIEWS, true);
    const ids = state.chosenKeywords.map(({keyword_index_id}) => keyword_index_id);
    return axios.get('/ajax/keywords/reviews', {params: {ids}})
        .then(({ data }) => commit(SET_EXISTING_KEYWORD_REVIEWS, data))
        .catch(axiosCatchHandler)
        .finally(() => commit(SET_LOADING_EXISTING_KEYWORD_REVIEWS, false))
  },
  startKeywordReview: ({ commit, dispatch }, keywords) => {
    commit(SET_REVIEW_ENABLED, true);
    return axios.post('/ajax/keywords/review', {ids: keywords})
      .then(async ({data}) => {
        await commit(SET_KEYWORD_REVIEWS, data);
        dispatch('pollKeywordReviews');
      })
      .catch(axiosCatchHandler)
  },
  async pollKeywordReviews({commit, dispatch, getters, state}) {
    if (
      state.keywordReviewPollingCount >= 200 ||
      !state.reviewEnabled ||
      (getters.keywordReviews.length > 0 && getters.pendingKeywordReviews.length <= 0)
    ) {
      commit(SET_REVIEW_POLL_COUNT, 0);
      return;
    }

    commit(SET_REVIEW_POLL_COUNT, state.keywordReviewPollingCount + 1);

    await dispatch('fetchKeywordReviews', {
      ids: getters.keywordIdsForReview,
    });

    await new Promise(resolve => setTimeout(resolve, 5000)); // Wait 5 seconds between poll requests

    return dispatch('pollKeywordReviews');
  },
  fetchKeywordReviews: ({ commit, dispatch }, data) =>
      axios.get('/ajax/keywords/reviews', {params: data})
          .then(({ data }) => commit(SET_KEYWORD_REVIEWS, data))
          .catch(e => axiosCatchHandler(e, () => dispatch('resetKeywordReview'))),
  resetKeywordReview({commit, dispatch}) {
    commit(SET_REVIEW_POLL_COUNT, 0);
    commit(SET_KEYWORD_REVIEWS, []);
    commit(SET_REVIEW_ENABLED, false);
  },
  generateSuggestedTopics: async ({ commit, state }) => {
    if (state.generatingSuggestedTopics) {
      return;
    }

    commit(SET_GENERATING_SUGGESTED_TOPICS, true);
    try {
      const { data } = await axios.post('/ajax/keywords/generate-suggested-topics');
      commit(SET_SUGGESTED_TOPICS, data);
    } catch (e) {
      axiosCatchHandler(e)
    } finally {
      commit(SET_GENERATING_SUGGESTED_TOPICS, false);
    }
  }
};

const mutations = {
  [ADD_KEYWORD_RANKING_REQUEST](state, keyword) {
    state.rankingKeywordRequests.push( // TODO: Could we thin these out too? The .post() is the promise already?
      new Promise((resolve, reject) => {
        axios.post('/strategy/get-keyword-ranking', {
          keyword
        }).then(({ data }) => {
          const rankingData = data.ranking_data;
          const index = state.newChosenKeywords.findIndex((newKeyword) => newKeyword.keyword === keyword.keyword);
          state.newChosenKeywords[index] = {...rankingData, ...state.newChosenKeywords[index]};
          resolve();
        }).catch((e) => {
          reject(e);
        });
      })
    );
  },
  [SET_CHOSEN_KEYWORDS](state, data){
    state.chosenKeywords = [...data.chosen_keywords];
    state.savedChosenKeywords = [...data.chosen_keywords];
    state.keywordLimit = data.keyword_limit;
  },
  [SET_PREVIOUS_TOPICS](state, data){
    state.previousTopics = data;
  },
  [SET_SUGGESTED_TOPICS](state, data){
    state.suggestedTopics = data;
  },
  [SET_GENERATING_SUGGESTED_TOPICS](state, bool) {
    state.generatingSuggestedTopics = bool;
  },
  [SET_SUGGESTIONS](state, {data, fresh}){
    const {next_page_url, data: suggestionsData} = data;
    const {suggestions} = state;
    if (fresh) {
      const table = document.querySelector('.table_body_wrap');
      if (table) {
        table.scrollTop = 0;
      }
      state.suggestions = [
        ...suggestionsData,
      ];
    } else {
      state.suggestions = [
        ...suggestions,
        ...suggestionsData,
      ];
    }
    state.nextPageUrl = next_page_url;
  },
  [ADD_NEW_CHOSEN_KEYWORD](state, keyword){
    let {newChosenKeywords} = state;
    newChosenKeywords.push(keyword);
    state.newChosenKeywords = [
      ...newChosenKeywords,
    ];
  },
  [ADD_NEW_CHOSEN_KEYWORDS](state, keywords){
    keywords.forEach(keyword => {
      state.newChosenKeywords.push(keyword);
    });
  },
  [CLEAR_NEW_CHOSEN_KEYWORD](state){
    state.newChosenKeywords = [];
  },
  [REMOVE_NEW_CHOSEN_KEYWORD](state, index){
    let {newChosenKeywords} = state;
    newChosenKeywords.splice(index, 1);
    state.newChosenKeywords = [
      ...newChosenKeywords,
    ];
  },
  [REMOVE_CHOSEN_KEYWORD](state, index){
    let {chosenKeywords, removeChosenKeywords} = state;
    let keyword = chosenKeywords[index];
    chosenKeywords.splice(index, 1);
    removeChosenKeywords.push(keyword);

    state.chosenKeywords = [
      ...chosenKeywords,
    ];
    state.removeChosenKeywords = [
      ...removeChosenKeywords,
    ];
  },
  [IGNORE_REMOVE_CHOSEN_KEYWORD]({removeChosenKeywords, chosenKeywords}, index){
    let keyword = removeChosenKeywords[index];
    keyword.remove = 0;
    removeChosenKeywords.splice(index, 1);
    chosenKeywords.push(keyword);

    state.chosenKeywords = [
      ...chosenKeywords,
    ];
    state.removeChosenKeywords = [
      ...removeChosenKeywords,
    ];
  },
  [CLEAR_REMOVE_CHOSEN_KEYWORDS](state){
    state.removeChosenKeywords = [];
  },
  [SET_KEYWORD_FILTER](state, filter){
    state.keywordFilter = filter;
    state.competitorFilter = null;
    state.searchFilter = null;
    state.typeFilter = null;
  },
  [SET_TYPE_FILTER](state, filter){
    state.typeFilter = filter;
    state.keywordFilter = null;
    state.competitorFilter = null;
    state.searchFilter = null;
  },
  [SET_COMPETITOR_FILTER](state, filter){
    state.competitorFilter = filter;
    state.keywordFilter = null;
    state.searchFilter = null;
    state.typeFilter = null;
  },
  [SET_SEARCH_FILTER](state, filter){
    state.searchFilter = filter;
  },
  [CLEAR_FILTER](state, key) {
    state[key] = null;
  },
  [SET_IGNORE_FILTERS](state, filters){
    state.ignoreFilters = filters;
  },
  [UPDATE_FILTER_COUNT](state, {key, count}){
    state.ignoreFilters[key].rows_ignored = count;
  },
  [CLEAR_ALL_FILTERS](state){
    state.typeFilter = null;
    state.keywordFilter = null;
    state.competitorFilter = null;
  },
  [SET_ONBOARDING_STATE](state, onboardingState){
    state.onboarding = onboardingState;
  },
  [SET_SHOW_CHOSEN_KEYWORDS_MODAL_STATE](state, modalState) {
    state.showChosenKeywordsModal = modalState;
  },
  [SET_SHOW_BLUK_ADD_MODAL_STATE](state, modalState) {
    state.showBulkAddModal = modalState;
  },
  [SET_BULK_ADD_PREFILL](state, prefill) {
    state.bulkAddPrefill = prefill;
  },
  [SET_SORT](state, sortBy) {
    if (state.sortBy === sortBy) {
      state.sortDirection = state.sortDirection === 'asc' ? 'desc' : 'asc';
      return;
    }
    state.sortBy = sortBy;
    state.sortDirection = sortBy === 'keyword' ? 'asc' : 'desc';
  },
  [SET_LOADING_EXISTING_KEYWORD_REVIEWS](state, status) {
    state.loadingExistingReviews = status;
  },
  [SET_EXISTING_KEYWORD_REVIEWS](state, reviews) {
    state.existingReviews = reviews;
  },
  [SET_KEYWORD_REVIEWS](state, reviews) {
    state.keywordReviews = reviews;
  },
  [SET_REVIEW_ENABLED](state, status) {
    state.reviewEnabled = status;
  },
  [SET_REVIEW_POLL_COUNT](state, count) {
    state.keywordReviewPollingCount = count;
  },
  [SET_ADDING_SUGGESTION](state, suggestion) {
    state.addingSuggestion = suggestion;
  },
  [SET_REMOVING_KEYWORD](state, keyword) {
    state.removingKeyword = keyword;
  },
  [SET_LOADING_SUGGESTIONS](state, status) {
    state.loadingSuggestions = status;
  },
  [SET_SAVING_KEYWORDS](state, saving) {
    state.savingKeywords = saving;
  }
};

const keywordIdeas = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default keywordIdeas;
